
import RiverPlumb from './img/testimonial_portraits/River_Plumb.webp';
import ElaineDunphy from './img/testimonial_portraits/Elaine_Dunphy.webp';
import MelissaDiaz from './img/testimonial_portraits/Melissa_Diaz.webp';
import FredBass from './img/testimonial_portraits/Fred_Bass.webp';
import SherrellSavage from './img/testimonial_portraits/Sherrell_Savage.webp';
import KellieChambers from './img/testimonial_portraits/Kellie_Chambers.webp';
import JennieMcDonald from './img/testimonial_portraits/Jennie_McDonald.webp';

const testimonials = {
  RiverPlumb: {
    name: '— River Plumb',
    quote: 'Through Nia I have self-healed chronic pain, strengthened my confidence, improved my memory, and deepened my connection with my spirit... I believe Nia is the most dynamic and accessible workout + lifestyle practice available.',
    location: 'Kansas, USA',
    photo: RiverPlumb,
    alt: 'River Plumb - Nia',
  },
  ElaineMarieDunphy: {
    name: '— Elaine Marie Dunphy',
    quote: 'From the moment I first stepped in, literally, it felt like coming home to my body! It changed, and continues to change my life, daily!',
    location: 'Newfoundland, Canada',
    photo: ElaineDunphy,
    alt: 'Elaine Marie Dunphy - Nia',
  },
  MelissaDiaz: {
    name: '— Melissa Diaz',
    quote: 'After a car accident, I was going to a chiropractor, a physical therapist and had just started Nia. I always felt better after doing Nia. I truly believe Nia helped me heal both physically and emotionally... I just knew I needed to share with others the healing power, the aliveness, and the Joy Nia has brought and continues to bring me.',
    location: 'California, USA',
    photo: MelissaDiaz,
    alt: 'Melissa Diaz - Nia',
  },
  FredBass: {
    name: '— Fred Bass',
    quote: 'I was a lifelong runner and at at 47 needed a hip replacement. I couldn’t run anymore, so I tried cycling and swimming but still had pain. Someone recommended I try Nia. After my first class, I wasn’t too sure... BUT, I noticed I had worked up a sweat, was a bit out of breath (cardio) AND I didn’t hurt.  After a year of practice, I came to the conclusion that this is a workout I can do for the REST OF MY LIFE, at any age, in any condition."',
    location: 'Oregon, USA',
    photo: FredBass,
    alt: 'Fred Bass - Nia',
  },
  SherrellSavage: {
    name: '— Sherrell Savage',
    quote: 'Nia is a great holistic practice to improve your health.',
    location: 'Maryland, USA',
    photo: SherrellSavage,
    alt: 'Sherrell Savage - Nia',
  },
  KellieChambers: {
    name: '— Kellie Chambers',
    quote: 'Nia helped me reconnect to my body when I was at a point in life where I felt stiff, old, and disconnected with my spirit. From that first class experience, I was hooked, it was like coming home to my body...',
    location: 'Oregon, USA',
    photo: KellieChambers,
    alt: 'Kellie Chambers - Nia',
  },
  JennieMcDonald: {
    name: '— Jennie McDonald',
    quote: 'I first discovered Nia when I was depressed, and Nia helped me find my way back to my body and myself again. Nia has been a powerful healing agent in my life, helping me regain joy as well as develop greater coordination and sensory awareness...If you’re looking for a fun, low-impact form of exercise that is also a body-mind practice, I’d recommend trying Nia. You may just fall in love with it, too!',
    location: 'Nevada, USA',
    photo: JennieMcDonald,
    alt: 'Jennie McDonald - Nia',
  },
};

export default testimonials;
